export interface FieldFormat {
  label: string;
  pattern: RegExp;
  placeholder: string;
  errorMessage: string;
  validate?: (value: string) => boolean;
}

const validateSIN = (sin: string): boolean => {
  let sinCopy: any = sin.replace(/\s/g, "");

  if (isNaN(sinCopy)) {
    return false;
  }

  if (sinCopy.length !== 9) {
    return false;
  }

  let numberArray: number[] = [];

  for (let position = 1; position <= 9; position++) {
    let digit = sinCopy % 10;
    sinCopy = (sinCopy / 10) >> 0;

    let multiplier = position % 2 === 1 ? 1 : 2;
    let multiplied = digit * multiplier;

    if (multiplied < 10) {
      numberArray[position - 1] = multiplied;
    } else {
      let sum = 0;
      let multipliedCopy = multiplied;
      for (let index = 0; index < 2; index++) {
        sum += multipliedCopy % 10;
        multipliedCopy = (multipliedCopy / 10) >> 0;
        numberArray[position - 1] = sum;
      }
    }
  }

  let summation = 0;
  for (let index = 0; index < numberArray.length; index++) {
    summation += numberArray[index];
  }

  return summation % 10 === 0;
};

const validateDate = (value: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

export const FIELD_FORMATS: Record<string, FieldFormat> = {
  phone: {
    label: "Phone number",
    pattern: /^\d{3}-\d{3}-\d{4}$/,
    placeholder: "XXX-XXX-XXXX",
    errorMessage: "Phone number must be in format XXX-XXX-XXXX",
  },
  sin: {
    label: "Social Insurance Number",
    pattern: /^\d{9}$/,
    placeholder: "9 digit SIN",
    errorMessage:
      "Invalid Social Insurance Number (SIN). Please enter the correct SIN and submit the form again.",
    validate: validateSIN,
  },
  postal_code: {
    label: "Postal code",
    pattern: /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/,
    placeholder: "A1A 1A1",
    errorMessage: "Postal code must be in Canadian format (e.g., A1A 1A1)",
  },
  address: {
    label: "Street address",
    pattern: /^.{10,}$/,
    placeholder: "123 Main Street",
    errorMessage:
      "Please enter a valid street address (at least 10 characters)",
  },
  date: {
    label: "Date",
    pattern: /^\d{4}-\d{2}-\d{2}$/,
    placeholder: "YYYY-MM-DD",
    errorMessage: "Date must be in format YYYY-MM-DD and be a valid date",
    validate: validateDate,
  },
};
